export default "__VITE_ASSET__CYxRaO9K__"